export default function getAmountPaid(order = {}) {
  if (!order.payments) return 0
  if (order.payments.length === 0) return 0

  return order.payments.reduce((amount, payment) => {
    if (payment.amount < 0) return amount
    return payment.amount + amount
  }, 0)
}
